const defaultOptions = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  trailingZeroDisplay: 'stripIfInteger',
};
const formatNumber = (
  input, // input number
  options = {},
) => {
  if (typeof input !== 'number') {
    return '--';
  }

  return Intl.NumberFormat('en-US', {
    ...defaultOptions,
    ...options,
  }).format(input);
};

export default formatNumber;
